function captureFrame(videoFile: File, frameNumber: number, fps: number = 30): Promise<string> {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = URL.createObjectURL(videoFile);

        const canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');

        if (!context) {
            reject('Could not get canvas context');
            return;
        }

        video.addEventListener('loadeddata', () => {
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;

            video.currentTime = frameNumber / fps; // Set time to capture the specified frame
        });

        video.addEventListener('seeked', () => {
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const imageData = canvas.toDataURL('image/jpeg');
            resolve(imageData);
        });

        video.addEventListener('error', err => {
            reject(`Error loading video: ${err}`);
        });
        video.load();
    });
}

export function createFileFromArrayBuffer(arrayBuffer: ArrayBuffer, fileName: string, mimeType: string): File {
    const blob = new Blob([arrayBuffer], { type: mimeType });
    return new File([blob], fileName, { type: mimeType });
}

export const base64VideoToImage = (
    base64String: string,
    frameNumber: number,
    fps: number = 24,
): Promise<HTMLImageElement> => {
    return new Promise((resolve, reject) => {
        const video = document.createElement('video');
        video.src = base64String;

        video.onloadeddata = () => {
            // Set the time to the specified frame (frameNumber / fps seconds)
            video.currentTime = frameNumber / fps;

            video.onseeked = () => {
                // Create a canvas to draw the video frame
                const canvas = document.createElement('canvas');
                canvas.width = video.videoWidth;
                canvas.height = video.videoHeight;
                const context = canvas.getContext('2d');

                if (context) {
                    // Draw the video frame onto the canvas
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);

                    // Create an image from the canvas
                    const img = new Image();
                    img.src = canvas.toDataURL('image/png');

                    img.onload = () => resolve(img);
                    img.onerror = error => reject(error);
                } else {
                    reject(new Error('Failed to get canvas context'));
                }
            };

            video.onerror = error => reject(error);
        };

        video.onerror = error => reject(error);
    });
};

export default captureFrame;
